import axios from "axios";
import { CONSTS } from "src/consts/consts";

const mainUrl = process.env.REACT_APP_MAIN_URL;
const loginUrl = mainUrl + CONSTS.AUTH_LOGIN_URL;
const registerUrl = mainUrl + CONSTS.AUTH_REGISTER_URL;

export const AuthService = {
  LOGIN_USER: (email, password) => {
    return axios.post(loginUrl, { email, password });
  },
  REGISTER_USER: (email, password, role) => {
    return axios.post(registerUrl, { email, password, role });
  },
};
